import { z } from "zod";
import { EDeliveryType } from "@zeal/common/dist/uhura";

export const newHireRecordSchema = z.object({
  type: z.enum(Object.values(EDeliveryType) as [string, ...string[]]),
  status: z.string(),
  sent_date: z.string(),
  record_id: z.string(),
  s3_key: z.string(),
});

export type INewHireRecord = z.infer<typeof newHireRecordSchema>;

export const newHireWorkerSchema = z.object({
  worker_id: z.string(),
  worker_type: z.enum(["employee", "contractor"]),
  first_name: z.string(),
  last_name: z.string(),
  company_id: z.string(),
  company_name: z.string(),
  state: z.string(),
  nhr_record: newHireRecordSchema.optional(),
});

export type INewHireWorker = z.infer<typeof newHireWorkerSchema>;

export const getNewHireWorkersRequestSchema = z.object({
  sent_date: z.string(),
  state: z.string(),
});

export type TGetNewHireWorkersRequest = z.infer<
  typeof getNewHireWorkersRequestSchema
>;

export const getNewHireWorkersResponseSchema = z.object({
  data: z.array(newHireWorkerSchema),
});

export type TGetNewHireWorkersResponse = z.infer<
  typeof getNewHireWorkersResponseSchema
>;
